import {
  ROOT_SELECTOR_SEPARATOR,
  ROOT_SELECTOR_CLASS_PREFIX,
  RESOLVER_CONTAINER_CLASS
} from '../constants';

function getRootSelectorClasses(url, classesLimit = 0) {
  if (!classesLimit || !url) return RESOLVER_CONTAINER_CLASS;

  const urlParts = url.split('/').filter(part => part);
  if (!urlParts.length) return `${RESOLVER_CONTAINER_CLASS} ${ROOT_SELECTOR_CLASS_PREFIX}`;

  const classes = urlParts.slice(0, classesLimit).reduce((acc, urlSection, index) => {
    const newClass = [!index ? ROOT_SELECTOR_CLASS_PREFIX : acc[index - 1], urlSection].join(
      ROOT_SELECTOR_SEPARATOR
    );
    acc.push(newClass);
    return acc;
  }, []);

  return `${RESOLVER_CONTAINER_CLASS} ${classes.join(' ')}`;
}

export default getRootSelectorClasses;
